var map = {
	"./accounts.mdx": 79542,
	"./adding-custom-styles.mdx": 46711,
	"./appcustomisation.mdx": 54783,
	"./appfeatures.mdx": 29822,
	"./appstore.mdx": 5546,
	"./attributes.mdx": 68333,
	"./auth.mdx": 58981,
	"./branch.mdx": 81056,
	"./build-marketplace.mdx": 40494,
	"./category.mdx": 52041,
	"./chat.mdx": 45562,
	"./checklist.mdx": 96664,
	"./cloudflare.mdx": 97621,
	"./collection.mdx": 31306,
	"./commerce-definitions.mdx": 65285,
	"./commission.mdx": 93878,
	"./composer.mdx": 87302,
	"./coupon.mdx": 44221,
	"./crowdfunding.mdx": 33864,
	"./currency.mdx": 52555,
	"./deeplinks.mdx": 30313,
	"./delivery.mdx": 54001,
	"./deployment.mdx": 74765,
	"./domain.mdx": 16112,
	"./dynamic-page.mdx": 26490,
	"./editing-page-styles.mdx": 49375,
	"./editor-overview.mdx": 90351,
	"./education.mdx": 18693,
	"./email.mdx": 56202,
	"./energy.mdx": 83073,
	"./facebookapp.mdx": 72512,
	"./firebase.mdx": 82471,
	"./food.mdx": 54309,
	"./ga.mdx": 56638,
	"./google-maps.mdx": 79015,
	"./growth.mdx": 89270,
	"./integrations-overview.mdx": 2784,
	"./inventory.mdx": 532,
	"./karix.mdx": 91662,
	"./language.mdx": 19660,
	"./listings.mdx": 30435,
	"./location.mdx": 44080,
	"./mangopay.mdx": 45708,
	"./media.mdx": 35857,
	"./negotiations.mdx": 88619,
	"./netlify.mdx": 90519,
	"./notifications.mdx": 57767,
	"./onlinepaymentplatform.mdx": 66625,
	"./order.mdx": 38714,
	"./othersolutions.mdx": 51157,
	"./paydunya.mdx": 96968,
	"./paymentgateways.mdx": 86890,
	"./playstore.mdx": 69382,
	"./products.mdx": 64703,
	"./promotion.mdx": 80180,
	"./qa-comments.mdx": 56090,
	"./razorpay.mdx": 14871,
	"./render.mdx": 14427,
	"./reports.mdx": 55181,
	"./revenuemodel.mdx": 96831,
	"./review-ratings.mdx": 16132,
	"./schedules.mdx": 76347,
	"./screens.mdx": 53410,
	"./search.mdx": 85485,
	"./seo.mdx": 63466,
	"./setup-app.mdx": 12952,
	"./social.mdx": 92787,
	"./stripe-connect.mdx": 20441,
	"./stripe-onboarding.mdx": 70232,
	"./stripe-payments.mdx": 2029,
	"./stuart.mdx": 84873,
	"./submit-template.mdx": 13002,
	"./subscription.mdx": 41476,
	"./tags.mdx": 8380,
	"./tax.mdx": 30526,
	"./template-create.mdx": 20160,
	"./testingapp.mdx": 43927,
	"./tracking.mdx": 66147,
	"./translations.mdx": 66730,
	"./twilio.mdx": 30896,
	"./users.mdx": 23237,
	"./variants.mdx": 1156,
	"./vercel.mdx": 12029,
	"./wallet.mdx": 23816,
	"./webhook.mdx": 71182,
	"./website.mdx": 84368,
	"./wishlist.mdx": 17207,
	"./zapier.mdx": 79390,
	"src/pages/docs/accounts.mdx": 79542,
	"src/pages/docs/adding-custom-styles.mdx": 46711,
	"src/pages/docs/appcustomisation.mdx": 54783,
	"src/pages/docs/appfeatures.mdx": 29822,
	"src/pages/docs/appstore.mdx": 5546,
	"src/pages/docs/attributes.mdx": 68333,
	"src/pages/docs/auth.mdx": 58981,
	"src/pages/docs/branch.mdx": 81056,
	"src/pages/docs/build-marketplace.mdx": 40494,
	"src/pages/docs/category.mdx": 52041,
	"src/pages/docs/chat.mdx": 45562,
	"src/pages/docs/checklist.mdx": 96664,
	"src/pages/docs/cloudflare.mdx": 97621,
	"src/pages/docs/collection.mdx": 31306,
	"src/pages/docs/commerce-definitions.mdx": 65285,
	"src/pages/docs/commission.mdx": 93878,
	"src/pages/docs/composer.mdx": 87302,
	"src/pages/docs/coupon.mdx": 44221,
	"src/pages/docs/crowdfunding.mdx": 33864,
	"src/pages/docs/currency.mdx": 52555,
	"src/pages/docs/deeplinks.mdx": 30313,
	"src/pages/docs/delivery.mdx": 54001,
	"src/pages/docs/deployment.mdx": 74765,
	"src/pages/docs/domain.mdx": 16112,
	"src/pages/docs/dynamic-page.mdx": 26490,
	"src/pages/docs/editing-page-styles.mdx": 49375,
	"src/pages/docs/editor-overview.mdx": 90351,
	"src/pages/docs/education.mdx": 18693,
	"src/pages/docs/email.mdx": 56202,
	"src/pages/docs/energy.mdx": 83073,
	"src/pages/docs/facebookapp.mdx": 72512,
	"src/pages/docs/firebase.mdx": 82471,
	"src/pages/docs/food.mdx": 54309,
	"src/pages/docs/ga.mdx": 56638,
	"src/pages/docs/google-maps.mdx": 79015,
	"src/pages/docs/growth.mdx": 89270,
	"src/pages/docs/integrations-overview.mdx": 2784,
	"src/pages/docs/inventory.mdx": 532,
	"src/pages/docs/karix.mdx": 91662,
	"src/pages/docs/language.mdx": 19660,
	"src/pages/docs/listings.mdx": 30435,
	"src/pages/docs/location.mdx": 44080,
	"src/pages/docs/mangopay.mdx": 45708,
	"src/pages/docs/media.mdx": 35857,
	"src/pages/docs/negotiations.mdx": 88619,
	"src/pages/docs/netlify.mdx": 90519,
	"src/pages/docs/notifications.mdx": 57767,
	"src/pages/docs/onlinepaymentplatform.mdx": 66625,
	"src/pages/docs/order.mdx": 38714,
	"src/pages/docs/othersolutions.mdx": 51157,
	"src/pages/docs/paydunya.mdx": 96968,
	"src/pages/docs/paymentgateways.mdx": 86890,
	"src/pages/docs/playstore.mdx": 69382,
	"src/pages/docs/products.mdx": 64703,
	"src/pages/docs/promotion.mdx": 80180,
	"src/pages/docs/qa-comments.mdx": 56090,
	"src/pages/docs/razorpay.mdx": 14871,
	"src/pages/docs/render.mdx": 14427,
	"src/pages/docs/reports.mdx": 55181,
	"src/pages/docs/revenuemodel.mdx": 96831,
	"src/pages/docs/review-ratings.mdx": 16132,
	"src/pages/docs/schedules.mdx": 76347,
	"src/pages/docs/screens.mdx": 53410,
	"src/pages/docs/search.mdx": 85485,
	"src/pages/docs/seo.mdx": 63466,
	"src/pages/docs/setup-app.mdx": 12952,
	"src/pages/docs/social.mdx": 92787,
	"src/pages/docs/stripe-connect.mdx": 20441,
	"src/pages/docs/stripe-onboarding.mdx": 70232,
	"src/pages/docs/stripe-payments.mdx": 2029,
	"src/pages/docs/stuart.mdx": 84873,
	"src/pages/docs/submit-template.mdx": 13002,
	"src/pages/docs/subscription.mdx": 41476,
	"src/pages/docs/tags.mdx": 8380,
	"src/pages/docs/tax.mdx": 30526,
	"src/pages/docs/template-create.mdx": 20160,
	"src/pages/docs/testingapp.mdx": 43927,
	"src/pages/docs/tracking.mdx": 66147,
	"src/pages/docs/translations.mdx": 66730,
	"src/pages/docs/twilio.mdx": 30896,
	"src/pages/docs/users.mdx": 23237,
	"src/pages/docs/variants.mdx": 1156,
	"src/pages/docs/vercel.mdx": 12029,
	"src/pages/docs/wallet.mdx": 23816,
	"src/pages/docs/webhook.mdx": 71182,
	"src/pages/docs/website.mdx": 84368,
	"src/pages/docs/wishlist.mdx": 17207,
	"src/pages/docs/zapier.mdx": 79390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66708;